import { render, staticRenderFns } from "./Typo3.vue?vue&type=template&id=6d3af3fc"
import script from "./Typo3.js?vue&type=script&lang=js&external"
export * from "./Typo3.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports